import React, {useState,useEffect} from "react";
import { read, utils } from 'xlsx';
import { getWithExpiry, setWithExpiry } from "../../common";
import configVars from "../../config";
import { useCookies } from "react-cookie";

const ImportUsers = (props) => {

    const [allOrganizations, setAllOrganizations] = useState([]);
    const [loadingOrganizations, setLoadingOrganizations] = useState(false);
    const [organization, setOrganization] = useState(0);
    const [teams, setTeams] = useState([]);
    const [loadingTeams, setLoadingTeams] = useState(false);
    const [selectedTeam, setSelectedTeam] = useState(0);
    const [userMembership, setUserMembership] = useState(0);
    const [cookies] = useCookies(["sustainyou_user_jwt"]);

    const [foundUsers, setFoundUsers] = useState([]);
    const [showProgressbar, setShowProgressbar] = useState(false);
    const [startImport, setStartImport] = useState(false);
    const [processedCount, setProcessedCount] = useState(0);
    const [currentUser, setCurrentUser] = useState('');
    const [importComplete, setImportComplete] = useState(false);
    const [failedUsers, setFailedUsers] = useState([]);
    const [showFailed, setShowFailed] = useState(false);
    const [showError, setShowError] = useState(false);


    useEffect(() => {
        getOrganizations();
      }, []);

    const getOrganizations = async () => {
        const savedOrganizations = getWithExpiry("sy_all_organizations");
    
        if (savedOrganizations) {
          setAllOrganizations(savedOrganizations);
        } else {
          setLoadingOrganizations(true);
    
          const response = await fetch(
            `${configVars.apiUrl}sustainchange/v1/getorganizations`,
            {
              method: "GET",
              headers: {
                Authorization: `Basic ${configVars.auth}`,
              },
            }
          );
    
          const companyResponse = await response.json();
    
          if (companyResponse) {
            if (companyResponse.success === true) {
              setAllOrganizations(companyResponse.data);
              setWithExpiry("sy_all_organizations", companyResponse.data);
            }
          }
    
          setLoadingOrganizations(false);
        }
      };

    const handleFileUpload = (e) => {

        e.preventDefault();
        if (e.target.files) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const data = e.target.result;
                const workbook = read(data);
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const usersJson = utils.sheet_to_json(worksheet);

                if ( usersJson && usersJson.length > 0 ) {
                    setFoundUsers( usersJson );
                    setShowProgressbar(true);
                }

            };
            
            reader.readAsArrayBuffer(e.target.files[0]);
        }

    }

    const sleep = (milliseconds) => {
        return new Promise(resolve => setTimeout(resolve, milliseconds))
    }

    const sendUserData = async ( users ) => {

            const fetchUrl = `${configVars.apiUrl}sustainchange/v1/importuser/`;

            for (let index = 0; index < users.length; index++) {
                const user = users[index];

                setProcessedCount( index+1 );

                const userinfo = getMatchingUserData( user );

                let userRequestData = new FormData();
                userRequestData.append( 'token', cookies.sustainyou_user_jwt );
                userRequestData.append( 'email', userinfo[0] );
                userRequestData.append( 'firstname', userinfo[1] );
                userRequestData.append( 'lastname', userinfo[2] );

                if ( userinfo[3] ) {
                    userRequestData.append( 'organisation', userinfo[3] );
                } else {
                    userRequestData.append( 'organisation', organization );
                }

                if ( userinfo[4] ) {
                    userRequestData.append( 'membership', userinfo[4] );
                } else {
                    userRequestData.append( 'membership', userMembership );
                }

                if ( userinfo[5] ) {
                    userRequestData.append( 'user_type', userinfo[5] );
                } else {
                    userRequestData.append( 'user_type', 'subscriber' );
                }

                if ( userinfo[6] ) {
                    userRequestData.append( 'user_team', userinfo[6] );
                } else {
                    userRequestData.append( 'user_team', selectedTeam );
                }

                if ( userinfo[7] ) {
                    userRequestData.append( 'job_type', userinfo[7] );
                }
            
                setCurrentUser( userinfo[0] );
                
                const response = await fetch(
                    fetchUrl,
                    {
                    method: "POST",
                    headers: {
                        Authorization: `Basic ${configVars.auth}`,
                    },
                    body: userRequestData
                    }
                );
                
                const updateResponse = await response.json();

                await sleep(1000);
        
                if ( updateResponse ) {

                    if ( ! updateResponse.success ) {
                        userinfo.splice(3, 0, updateResponse.message )
                        setFailedUsers( prevArray => [...prevArray, userinfo]);
                    }

                }
            }

           

    }

    const getMatchingUserData = ( user ) => {

        if ( ! user ) return;

        let email;
        let firstname;
        let lastname;
        let company;
        let membership;
        let type;
        let team;
        let jobtype;

        if ( user['E-post'] ) {
            email = user['E-post'];
        } else if ( user.email ) {
            email = user.email;
        }

        if ( user['FÃ¶rnamn'] ) {
            firstname = user['FÃ¶rnamn'];
        } else if ( user['Förnamn'] ) {
            firstname = user['Förnamn'];
        } else if ( user['firstname'] ) {
            firstname = user['firstname'];
        } else if ( user['fornamn'] ) {
            firstname = user['fornamn'];
        } else if ( user['Fornamn'] ) {
            firstname = user['Fornamn'];
        }

        if ( user['Efternamn'] ) {
            lastname = user['Efternamn'];
        } else if ( user['efternamn'] ) {
            lastname = user['efternamn'];
        } else if ( user['lastname'] ) {
            lastname = user['lastname'];
        }

        if ( user.company ) {
            company = user.company;
        }

        if ( user.membership ) {
            membership = user.membership;
        }

        if ( user.type ) {
            type = user.type;
        }

        if ( user.team ) {
            team = user.team;
        }

        if ( user.jobtype ) {
            jobtype = user.jobtype;
        }

        if ( (!firstname || ( firstname && firstname.match(/\S/g).length < 1 )) && email && email.length > 1 ) {
            firstname = email.substring(0, email.indexOf("@"));
        }

        let returnData = [ email, firstname, lastname ];

        if ( company ) {
            returnData.push( company );
        }

        if ( membership ) {
            returnData.push( membership );
        }

        if ( type ) {
            returnData.push( type );
        }

        if ( team ) {
            returnData.push( team );
        }

        if ( jobtype ) {
            returnData.push( jobtype );
        }

        return returnData;

    }

    const triggerUserImport = () => {

        if ( startImport ) return;

        if ( ! foundUsers ) return;

        if ( foundUsers.length < 1 ) return;

        if ( ! userMembership ) {
            setShowError(true);
            return;
        }

        setStartImport( true );

        sendUserData( foundUsers ).then(() => {
            setStartImport(false);
            setImportComplete(true);
        })

    }

    const clearImportData = () => {
        setStartImport( false );
        setImportComplete(false);
        setFoundUsers([]);
        setShowProgressbar(false);
        setProcessedCount(0);
        setCurrentUser('');
        setFailedUsers([]);
    }

    const handleOrgSelect = async ( orgID ) => {

        if ( !orgID || parseInt( orgID, 10 ) === 0 ) {
            setOrganization('');
            setTeams([]);

            return;
        }

        setOrganization( orgID );

        const orgTeams = getWithExpiry(`org_${orgID}_teams`);

        if ( orgTeams ) {
            setTeams( orgTeams );
        } else {

            setLoadingTeams(true);
            setTeams([]);

            const response = await fetch(
                `${configVars.apiUrl}sustainchange/v1/getorgteams/?org_id=${orgID}`,
                {
                  method: "GET",
                  headers: {
                    Authorization: `Basic ${configVars.auth}`,
                  },
                }
              );
        
                const teamsResponse = await response.json();
            
                if (teamsResponse) {
                    if ( teamsResponse.success === true && teamsResponse.data.length > 0 ) {
                        setTeams( teamsResponse.data );
                        setWithExpiry(`org_${orgID}_teams`, teamsResponse.data);
                    }
                }

                setLoadingTeams(false);

        }

    }

    return(
        <div className="user-import-wrap">
            <h3 className="mb-4">Import users from Excel and CSV</h3>

                <div className="row mb-3 user-row">
                    <div className="col-12 col-lg-6">
                        <div className="row">
                            <div className="col">
                                <select
                                className="form-select"
                                aria-describedby="companyHelp"
                                value={organization}
                                onChange={(e) => handleOrgSelect(e.target.value)}
                                >
                                {loadingOrganizations && (
                                    <option value="0">Loading organizations...</option>
                                )}
                                {!loadingOrganizations && (
                                    <option value="0">Select user organization</option>
                                )}
                                {allOrganizations &&
                                    allOrganizations.length > 0 &&
                                    allOrganizations.map((organization, index) => {
                                    return (
                                        <option value={organization.id} key={index}>
                                        {organization.name}
                                        </option>
                                    );
                                    })}
                                </select>
                            </div>

                            {loadingOrganizations && (
                                <div className="col-auto">
                                    <div
                                        className="spinner-border text-primary spinner-border-sm mt-3"
                                        role="status"
                                    >
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="col-12 col-lg-6">
                        <div className="row">
                        <div className="col">
                            <select
                            className="form-select"
                            aria-describedby="companyHelp"
                            value={userMembership}
                            onChange={(e) => setUserMembership(e.target.value)}
                            >
                            {props?.loadingMemberships && (
                                <option value="0">Loading memberships...</option>
                            )}
                            {!props?.loadingMemberships && (
                                <option value="0">Select user membersip plan</option>
                            )}

                            {props?.allMemberships &&
                                props?.allMemberships.length > 0 &&
                                props?.allMemberships.map((membership, index) => {
                                return (
                                    <option value={membership.id} key={index}>
                                    {membership.name}
                                    </option>
                                );
                                })}
                            </select>

                            { showError && ! userMembership &&
                                <p className="text-secondary font-size-medium">Please select user membership to continue</p>
                            }
                        </div>
                        {props?.loadingMemberships && (
                            <div className="col-auto">
                            <div
                                className="spinner-border text-primary spinner-border-sm mt-3"
                                role="status"
                            >
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            </div>
                        )}
                        </div>
                    </div>
            </div>
            
            { organization !== 0 && teams.length > 0 && (
                <div className="row mb-3 user-row">
                    <div className="col-12 col-lg-6">
                        <div className="row">
                            <div className="col">
                                <select className="form-select" value={selectedTeam} onChange={(e) => setSelectedTeam(e.target.value)}>
                                    <option value="">Select team</option>

                                    {teams && teams.length > 0 &&
                                        <>
                                            {teams.map( (team, i) => {
                                                return (
                                                    <option value={team.id} key={i}>{team.name}</option>
                                                );
                                            })}
                                        </>
                                    }

                                </select>
                            </div>
                            {loadingTeams && (
                                <div className="col-auto">
                                    <div
                                        className="spinner-border text-primary spinner-border-sm mt-3"
                                        role="status"
                                    >
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            <div className="row">
                <div className="col-12 mt-3">
                    <label className="form-label">Choose user data file</label>
                    <input className="form-control" type="file" id="users_data_file" onChange={(e) => handleFileUpload(e)} />
                    
                    { showProgressbar && !showFailed &&
                        <div className="my-4">
                            <div className="toast fade show w-100" role="alert" aria-live="assertive" aria-atomic="true">

                                {startImport &&
                                    <div className="toast-header">
                                        <strong className="me-auto">{`${processedCount} / ${foundUsers.length}`}</strong>
                                        { currentUser &&
                                            <small className="text-muted">importing {currentUser} ...</small>
                                        }
                                    </div>
                                }
                                { importComplete &&
                                    <div className="toast-header">
                                        <strong className="me-auto">User import completed. <i className="fa fa-check" aria-hidden="true"></i></strong>
                                        <button type="button" className="btn-close" data-bs-dismiss="toast" aria-label="Close" onClick={() => clearImportData()}></button>
                                    </div>
                                }
                                <div className="toast-body">

                                    { importComplete &&
                                        <div className="px-3">
                                            <div className="d-flex my-3 align-items-center">
                                                <h5>Successful user imports:</h5>
                                                <span className="py-1 px-3 ms-2 text-success h4">{(processedCount) - failedUsers.length}</span>
                                            </div>
                                            { failedUsers.length > 0 &&
                                                <div className="d-flex align-items-center">
                                                    <h5>Failed user imports:</h5>
                                                    <span className="py-1 px-3 ms-2 text-secondary h4">{failedUsers.length}</span>
                                                    <button type="button" className="btn py-0 text-secondary btn-link" onClick={() => setShowFailed(true)}>View failed users <i className="fa fa-long-arrow-right" aria-hidden="true"></i></button>
                                                </div>
                                            } 
                                        </div>
                                    }
                                    
                                    { !startImport && !importComplete &&
                                        <p>
                                            { foundUsers.length } users found. 
                                            { foundUsers.length > 10 &&
                                                <>This will take a while to complete the user import. Please don't close the tab or navigate away while the import is running.</>
                                            }
                                        </p>
                                    }

                                    { startImport &&
                                        <div className="my-3">
                                            <div className="mb-3 d-flex">
                                                <span className="text-success flex-grow-1">Success: <strong>{(processedCount) - failedUsers.length}</strong></span>
                                                <span className="text-secondary">Failed: <strong>{failedUsers.length}</strong></span>
                                            </div>
                                            <div className="progress">
                                                <div className="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar" aria-valuenow={parseInt( ((processedCount)/foundUsers.length)*100, 10 )} aria-valuemin="0" aria-valuemax="100" style={{width: `${((processedCount)/foundUsers.length)*100}%`}}>
                                                    {`${parseInt( ((processedCount)/foundUsers.length)*100, 10 )}%`}
                                                </div>
                                            </div>
                                        </div>
                                    }

                                    { !importComplete &&
                                        <div className="mt-2 pt-2 d-flex justify-content-end">
                                            <button type="button" className="btn btn-secondary" onClick={() => triggerUserImport()}>
                                                {!startImport &&
                                                    <span>Start import</span>
                                                }
                                                { startImport &&
                                                    <>
                                                        <span className="pe-2">Importing</span>
                                                        <div className="spinner-border spinner-border-sm" role="status">
                                                            <span className="visually-hidden">Loading...</span>
                                                        </div>
                                                    </>
                                                }
                                            </button>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    }

                    { showFailed &&
                        <div className="my-4">
                            <div className="mb-3 d-flex justify-content-end">
                                <div>
                                    <span>Close</span>
                                    <button type="button" className="btn-close" data-bs-dismiss="toast" aria-label="Close" onClick={() => setShowFailed(false)}></button>
                                </div>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-sm table-striped table-hover align-middle">
                                    <thead>
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col">Förnamn</th>
                                            <th scope="col">Efternamn</th>
                                            <th scope="col">E-post</th>
                                            <th scope="col">Fel</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        { failedUsers.map( (item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <th scope="row" className="font-size-medium">{index+1}</th>
                                                    <td className="font-size-medium">{item[1]}</td>
                                                    <td className="font-size-medium">{item[2]}</td>
                                                    <td className="font-size-medium">{item[0]}</td>
                                                    <td className="font-size-medium">{item[3]}</td>
                                                </tr>
                                            );
                                        })}
                                        
                                    </tbody>
                            
                                </table>
                            </div>
                        </div>
                    }

                </div>
            </div>

        </div>
    )

}

export default ImportUsers;